(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoicelog', {
            parent: 'entity',
            url: '/invoicelog?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Billing'
            },
            views: {
               'content@': {
                    templateUrl: 'app/pages/invoice-log/invoiceslog.html',
                    controller: 'InvoiceLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                billingAccess: ['BillingAccess', function(BillingAccess) {
                    return BillingAccess.requireAccess();
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
    }

})();
